// extracted by mini-css-extract-plugin
export default {"container":"container--3a493","header":"header--3BIQD","avatar":"avatar--1AHUJ","content":"content--1Fyp0"};